import { createSlice } from "@reduxjs/toolkit";

export const initialDMPState = () => {
    return {
        audienceSegments: [],
        adAudiences: [],
        audienceSegmentsLoaded: false,
        preferences: {},
    };
};

const receiveAudiences = (state, payload) => {
    const { audienceSegments, adAudiences } = payload;
    return {
        ...state,
        audienceSegments: [...audienceSegments],
        adAudiences: [...adAudiences],
        audienceSegmentsLoaded: true,
    };
};

const updatePreference = (state, payload) => {
    const { namespace, key, value } = payload;
    let container = state.preferences[namespace] || {};
    return {
        ...state,
        preferences: {
            ...state.preferences,
            [namespace]: { ...container, [key]: value },
        },
    };
};

const updatePreferences = (state, payload) => {
    const { namespace, preferences } = payload;
    let container = state.preferences[namespace] ?? {};
    return {
        ...state,
        preferences: {
            ...state.preferences,
            [namespace]: { ...container, ...preferences },
        },
    };
};

const receivePreferences = (state, payload) => {
    const { namespace, preferences } = payload;
    return {
        ...state,
        preferences: {
            ...state.preferences,
            [namespace]: { ...preferences },
        },
    };
};

const dmpSlice = createSlice({
    name: "dmp",
    initialState: initialDMPState(),
    reducers: {
        receive_audiences: (state, action) => {
            return receiveAudiences(state, action.payload);
        },
        update_ns_preference: (state, action) => {
            return updatePreference(state, action.payload);
        },
        update_ns_preferences: (state, action) => {
            return updatePreferences(state, action.payload);
        },
        receive_ns_preferences: (state, action) => {
            return receivePreferences(state, action.payload);
        },
    },
});

export const {
    receive_audiences,
    update_ns_preference,
    update_ns_preferences,
    receive_ns_preferences,
} = dmpSlice.actions;

export default dmpSlice.reducer;
